import { useState, useEffect, useRef } from "react";
import { motion, AnimatePresence } from "framer-motion";

import useAppStore from '../../store/useAppStore'
import useLayoutStore from '../../store/useLayoutStore'
import SearchBar from './SearchBar';

const ViewPresenceHeader = () => {
    const presenceVisibility = useAppStore((state) => state.presenceVisibility);
    const setPresenceVisibility = useAppStore((state) => state.setPresenceVisibility);

    const isDarkTheme = useLayoutStore(state => state.isDarkTheme)
    const activeThemeClass = isDarkTheme ? 'dark-color' : 'white-color'

    const handleVisibilityChange = (e) => {
        const target = e.target.closest('[data-name]');
        if (!target) return;
        const name = target.getAttribute('data-name');
        setPresenceVisibility(name);
    }

    return (
        <div className="view-header-container">
            <div className="view-header-top">
                <div className={`v-header-name ${activeThemeClass}`}>Prisutnost</div>
                <div className={`v-header-description ${isDarkTheme ? "dark-color" : ""}`}>Prikazuju se evidentirani zaposleni, informacije o vremenu dolaska na posao, ukupno vreme na pauzama, predviđeno vreme izlaska kao i način prijave (tag ili online prijava). Moguće je prikazati sve zaposlene, izvršiti pretragu ili prikazati zaposlene koji su tog dana bili prisutni, bez obzira na trenutni status.</div>
                <div className="v-header-tools-container presence-tools-container">
                    <div className="v-header-buttons-div" onClick={handleVisibilityChange}>
                        <PresenceHeaderButton
                            name="currentActive"
                            active={presenceVisibility === "currentActive"}
                            icon="./views/TrenutnoPrisutan1.svg"
                            tooltip="Trenutno prisutni"
                        />
                        <PresenceHeaderButton
                            name="todayActive"
                            active={presenceVisibility === "todayActive"}
                            icon="./views/Danas.svg"
                            tooltip="Danas prisutni"
                        />
                        <PresenceHeaderButton
                            name="allEmployees"
                            active={presenceVisibility === "allEmployees"}
                            icon="./views/SviPrisutni.svg"
                            tooltip="Svi zaposleni"
                        />
                    </div>
                    <SearchBar />

                </div>
            </div>
        </div>
    )
}

const PresenceHeaderButton = ({ name, active, icon, tooltip }) => {
    const isTouchDevice = useLayoutStore(state => state.isTouchDevice);
    const isDarkTheme = useLayoutStore(state => state.isDarkTheme)

    const activeClass = isDarkTheme ? 'dark-active' : 'active'

    const [isHovered, setIsHovered] = useState(false);

    return (
        <div className="v-header-button-div">
            <button
                className={`v-header-icon-button ${active ? activeClass : ""}`}
                data-name={name}
                onMouseEnter={() => !isTouchDevice && setIsHovered(true)}
                onMouseLeave={() => !isTouchDevice && setIsHovered(false)}
            >
                <img src={icon} alt={name} className={`${isDarkTheme ? 'dark-filter' : ''}`} />
            </button>
            <AnimatePresence>
                {isHovered && (
                    <motion.div
                        className={`v-header-button-tooltip  ${isDarkTheme ? 'tooltip-dark' : 'tooltip-white'}`}
                        initial={{ opacity: 0, y: -14 }}
                        animate={{ opacity: 1, y: 0 }}
                        exit={{ opacity: 0, y: -14 }}
                        transition={{ duration: 0.19, ease: "easeOut" }}
                    >
                        {tooltip}
                    </motion.div>
                )}
            </AnimatePresence>
        </div>
    );
};

export default ViewPresenceHeader
